import { observer } from "mobx-react";
import * as React from "react";
import Localization from "../core/Localization";
import { TableChildProps } from "../coreui/Table";
import Typography from "../coreui/Typography";
import { selectionContext } from "../coreui/Table";

interface Props {
  dataId: string;
  name: string;
  propagated: TableChildProps;
}

export class GridSelectedCount extends React.Component<Props> {
  static contextType = selectionContext;

  public render() {
    const { selectedCount } = this.context;

    return selectedCount === 0 ? null : (
      <Typography variant="body2">
        {Localization.getBuiltInMessage("numberSelected", {
          numSelected: selectedCount.toString(),
        })}
      </Typography>
    );
  }
}

export default observer(GridSelectedCount);
